'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    SubtreeContext: function() {
        return SubtreeContext;
    },
    useSubtreeContext_unstable: function() {
        return useSubtreeContext_unstable;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
/**
 * @internal
 */ const defaultSubTreeContextValue = {
    level: 0,
    contextType: 'subtree'
};
const SubtreeContext = /*#__PURE__*/ _react.createContext(undefined);
const useSubtreeContext_unstable = ()=>{
    var _React_useContext;
    return (_React_useContext = _react.useContext(SubtreeContext)) !== null && _React_useContext !== void 0 ? _React_useContext : defaultSubTreeContextValue;
};
